import * as React from 'react';
import { SVGProps } from 'react';

export const StoreIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3 9v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="M20.485 3h-3.992l.5 5s1 1 2.5 1a3.23 3.23 0 0 0 2.14-.806.503.503 0 0 0 .15-.465L21.075 3.5a.6.6 0 0 0-.59-.5Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="m16.493 3 .5 5s-1 1-2.5 1-2.5-1-2.5-1V3h4.5Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="M11.993 3v5s-1 1-2.5 1-2.5-1-2.5-1l.5-5h4.5Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="M7.493 3h-3.99a.6.6 0 0 0-.593.501L2.205 7.73a.506.506 0 0 0 .15.465c.328.29 1.061.806 2.138.806 1.5 0 2.5-1 2.5-1L7.493 3Z"
      stroke="currentColor"
      strokeWidth={1.5}
    />
    <path
      d="M14.5 15h-5v6h5v-6Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default StoreIcon;
